import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="rounded-3xl overflow-hidden mb-10 md:mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20concept%20of%20community%20and%20connection%2C%20dark%20moody%20background%20with%20warm%20yellow-green%20glowing%20accents%2C%20people-like%20silhouettes%20in%20abstract%20form%2C%20film%20grain%20texture%2C%20cinematic%20lighting%2C%20modern%20magazine%20aesthetic%20with%20negative%20space&width=1200&height=600&seq=cta-home-visual&orientation=landscape"
            alt="加入51吃瓜社区"
            title="51吃瓜网站入口 - 加入吃瓜社区"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-snug">
          不想错过任何一个<span className="font-serif italic text-accent-600">大瓜</span>？
        </h2>
        <p className="mt-3 text-sm text-foreground-600">
          每天都有新鲜热辣的吃瓜内容等你来挖
        </p>
        <p className="text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
          关注51吃瓜，第一时间获取网红黑料、塌房现场、吃瓜爆料等全网最热资讯
        </p>

        <Link
          to="/category/meiri-dasai"
          className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          立即开始吃瓜
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}